import requests from './httpService';
import getEmployeeId from 'utils/commonAdmin';

const TripadvanceServices = {
	getTripadvanceList: async (type, body) => {
		const id_employee = await getEmployeeId();
		return requests.post(`/tripAdvance/list/${type}`, body);
	},
	tripadvanceRequestList: async (body) => {
		return requests.post(`/tripAdvance/request`, body);
	},
	tripadvanceStatus: async (id, body) => {
		return requests.put(`/tripadvance/update/tripadvance/${id}`, body);
	},
	tripadvanceRequest: async (id, body) => {
		return requests.post(`/tripadvance/rerequest/${id}`, body);
	},
	tripadvanceReport: async (body) => {
		return requests.post(`/tripadvance/report`, body);
	},
};

export default TripadvanceServices;
